const INPUT_HEIGHT = 48;

export const formTextFieldStyles = {
	root: (canAddNewItem?: boolean) => ({
		width: '100%',
		display: 'grid',
		gridTemplateColumns: {
			xs: '1fr',
			sm: 'min-content 1fr'
		},
		alignItems: canAddNewItem ? 'flex-start' : 'center',
		gap: 1
	}),

	label: {
		pt: 1,
		height: '100%',
		minWidth: 200,
		typography: 'subtitle1',
		color: 'text.primary',
		userSelect: 'none',
		fontWeight: '700',
		pointerEvents: 'none'
	},

	fieldWrap: {
		gridTemplateColumns: {
			xs: '1fr min-content'
		},
		display: 'grid',
		position: 'relative',
		width: '100%'
	},

	field: {
		position: 'relative'
	},

	textField: (indicateError: boolean, isDirty: boolean) => ({
		backgroundColor: 'background.paper',
		width: '100%',

		'& .MuiInputBase-root': {
			height: `${INPUT_HEIGHT}px !important`
		},

		// Input text color
		'& .MuiOutlinedInput-input': {
			color: indicateError
				? 'var(--mui-palette-error-main)'
				: isDirty
					? 'var(--mui-palette-success-light)'
					: 'var(--mui-palette-text-primary)',
			WebkitTextFillColor: 'currentColor',
			pr: 12
		},

		// Border color
		'& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
			borderColor: indicateError
				? 'var(--mui-palette-error-main)'
				: isDirty
					? 'var(--mui-palette-success-light)'
					: 'var(--mui-palette-divider)',
			borderWidth: 1
		},

		'& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: indicateError
				? 'var(--mui-palette-error-main)'
				: isDirty
					? 'var(--mui-palette-success-light)'
					: 'var(--mui-palette-action-hover)',
			borderWidth: 1
		},

		// Focus still primary blue (never overridden)
		'& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: 'primary.main',
			borderWidth: 1
		},

		'& .MuiOutlinedInput-root': {
			height: '100%'
		},

		'& .MuiFormHelperText-root': {
			margin: 0
		}
	}),

	dateField: (indicateError: boolean, isDirty: boolean) => ({
		'& .MuiPickersOutlinedInput-input': {
			color:
				isDirty && !indicateError
					? 'var(--mui-palette-success-light)'
					: undefined,
			WebkitTextFillColor:
				isDirty && !indicateError ? 'currentColor' : undefined
		},
		'& .MuiPickersOutlinedInput-notchedOutline': {
			borderColor:
				isDirty && !indicateError
					? 'var(--mui-palette-success-light)'
					: undefined,
			borderWidth: isDirty && !indicateError ? 1 : undefined
		}
	}),

	badgeWrap: {
		position: 'absolute',
		right: '12px',
		top: INPUT_HEIGHT / 2,
		transform: 'translateY(-50%)',
		display: 'flex',
		alignItems: 'center',
		gap: 0.5,
		pointerEvents: 'none'
	},

	requiredChip: {
		bgcolor: 'grey.100',
		color: 'text.secondary',
		borderRadius: '16px',
		height: 24,
		fontSize: 12
	},

	removeButton: {
		margin: 0,
		marginLeft: 1,
		// don't stretch to match the field's height (which grows with the error message)
		alignSelf: 'start',
		marginTop: 1.5
	},

	addNewItemButtonWrap: {
		display: 'flex',
		justifyContent: 'flex-start',
		alignItems: 'center',
		width: 'fit-content',
		marginTop: 1
	}
};
